/* src/app/components/header/header.component.css */
header {
  padding: 10px;
  background-color: #ffffff;
}
.mat-mdc-menu-content {
  margin: 0;
  padding: 8px 3;
  list-style-type: none;
  background-color: #BDBDBD;
}
.logo {
  width: 171.4px;
}
.logo:hover {
  cursor: pointer;
}
.desktop_menu {
  margin-top: 4px;
}
.desktop_menu ul {
  padding: 0;
  margin: 0;
}
.desktop_menu ul li {
  list-style-type: none;
  color: white;
  display: inline-block;
  font-size: 16px;
  margin-left: 20px;
}
i {
  color: #9cd41c;
}
a {
  color: #BDBDBD;
  font-size: 16px;
  font-weight: bold;
}
a:hover,
a:focus,
a:active {
  color: #9cd41c;
  text-decoration: none;
  font-weight: bold;
}
.desktop_menu ul li a:hover {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  color: #9cd41c;
}
.menu-icon {
  display: none;
}
.headerStyleMenu {
  padding: 5px;
}
@media screen and (min-width: 128px) and (max-width: 932px) {
  .desktop_menu {
    position: fixed;
    transition: 0.4s ease-in-out;
    right: -280px;
    top: 64px;
    width: 280px;
    height: 100%;
  }
  .desktop_menu ul li {
    display: block;
    text-align: center;
    margin: 0;
    padding: 10px 0 10px 26px;
    border-bottom: 1px solid #9cd41c;
  }
  .menu-icon {
    display: block;
    color: white;
    font-size: 40px;
    padding-top: 10px;
  }
  .mobile_menu {
    right: 0;
    transition: 0.4s ease-in-out;
    z-index: 5;
    background: rgba(255, 255, 255, 0.30);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    border: 1.5px solid rgba(209, 213, 219, 0.3);
  }
  .card .card-header {
    z-index: 0;
  }
}
/*# sourceMappingURL=header.component.css.map */
